import React, { useCallback, useMemo } from 'react';

import SortOptions from 'components/uiLibrary/Inputs/SortOptions';

import { SUB_COMPONENTS } from 'components/Globals/Analytics/constants';

import { TP, SORT_OPTION_VALUES } from 'constants/index';

import useNavigate from 'utils/hooks/useNavigate';

import { useTranslation } from 'src/i18n';

import { QUERY_PARAMS_RESERVED } from 'operabase-router/constants';

import classes from './ProductionSortOptions.module.scss';

const ProductionSortOptions = ({ value: selectedSortValue, setSortBy, trackingData = {} }) => {
  const { t } = useTranslation('NS_APP_GLOBALS');
  const navigate = useNavigate();

  const handleSortChange = useCallback(
    value => {
      setSortBy(value);
      navigate.updateQueryParams({
        appendParams: {
          [QUERY_PARAMS_RESERVED.SORT_BY]: value,
        },
        deleteParams: [QUERY_PARAMS_RESERVED.VIEW_MODE],
      });
    },
    [navigate, setSortBy],
  );

  const options = useMemo(
    () => [
      { label: t(`${TP}.FN_SORT_BY_RECOMMENDED`), value: SORT_OPTION_VALUES.FEATURED_DESC },
      { label: t(`${TP}.m_DATE`), value: SORT_OPTION_VALUES.YEAR_ASC },
    ],
    [t],
  );

  return (
    <div className={classes.root}>
      <SortOptions
        options={options}
        value={selectedSortValue}
        onSelect={handleSortChange}
        trackingData={{
          ...trackingData,
          subComponent: SUB_COMPONENTS.SORT_OPTIONS,
        }}
        styles={{
          selectedOption: classes.selectedOption,
        }}
      />
    </div>
  );
};

export default ProductionSortOptions;
